import React, { useEffect } from 'react';
import { actions } from 'redux/actions';
import { useSelector } from 'react-redux';
import { isEmptyArray, _t } from 'utils';
import moment from 'moment';
import Icon from 'screens/shared/icon';
import Shared from 'screens/shared';
import CreateForm from 'screens/shared/nics/create';
import { ROUTE } from 'constant';
import { ACTIONS_TYPES } from 'redux/helper';
import { featuresToggle } from 'utils/features-toggle';
import FirewallRules from './firewall';
import FlowLog from './flowlog';
import DirectionArrow from './firewall/direction-arrow';

export default ({ history, match }) => {
  const { dcId, serverId, id: nicId } = match.params;

  const { [ACTIONS_TYPES.NIC.GET]: nic = {}, [ACTIONS_TYPES.DATA_CENTER.GET]: datacenter } = useSelector((e) => e);
  const {
    id = '', properties = {}, metadata = {}, entities = {},
  } = nic;
  const isControlled = false;

  useEffect(() => {
    actions.nic.get({ dcId, serverId, nicId });
    actions.dataCenter.get({ id: dcId });
  }, [dcId, serverId, nicId]);

  const renderBoolean = (value) => (value
    ? <Icon name="check" className="color-success f-22" />
    : <Icon name="times" className="color-danger f-22" />);

  const propertiesRows = [
    ['LAN', <Shared.utilities.LAN id={properties?.lan} />],
    ['IPs', isEmptyArray(properties?.ips) ? 'No IPs' : <Shared.utilities.IPs ips={properties?.ips || []} />],
    ['MAC', properties?.mac],
    ['Firewall State', renderBoolean(properties?.firewallActive)],
    ['Firewall Direction', <DirectionArrow type={properties?.firewallType} />],
    ['DHCP', renderBoolean(properties?.dhcp)],
    ['NAT', renderBoolean(properties?.nat)],
    [_t('Last Updated'), moment(metadata?.lastModifiedDate).fromNow()],
  ];

  const deleteHandler = () => {
    actions.nic.delete({ dcId, nicId, serverId });
    history.goBack();
  };

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.NIC}
      strapIcon="ethernet"
      strapTitle={properties?.name}
      onDelete={deleteHandler}
      editForm={<CreateForm item={{ id, ...properties }} isEdit />}
      editAction={ACTIONS_TYPES.NIC.UPDATE}
    >
      <Shared.widgets.Properties properties={propertiesRows} />
      <FirewallRules rules={entities?.firewallrules?.items || []} readonly={isControlled} {...{ dcId, serverId, nicId }} />
      {featuresToggle.isExistInDatacenter(datacenter, 'flow-logs') && <FlowLog {...{ dcId, serverId, nicId }} />}
    </Shared.widgets.Page>
  );
};
